// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3VNbE","file":"styles_file__1HaBr"};